import React, { useContext } from "react";
import { ConfirmDialog } from "sprint-common-web";

import { useFileRecordApi } from "../../../../../common/api/master-api/file-records/useFileRecordApi";
import { FileRecordListingContext } from "../../context/FileRecordListingContext";

interface ApproveFileRecordNotificationsDialogProps {
    onClose(): void;
    isOpen: boolean;
    itemId: string;
}

export const ApproveFileRecordNotificationsListingDialog: React.VFC<ApproveFileRecordNotificationsDialogProps> = ({
    onClose,
    isOpen,
    itemId
}: ApproveFileRecordNotificationsDialogProps) => {
    const { approveFileRecordNotifications } = useFileRecordApi();

    const { approveNotifications } = useContext(FileRecordListingContext);

    const handleConfirmation = async () => {
        await approveFileRecordNotifications({ fileRecordId: itemId });

        approveNotifications(itemId);

        onClose();
    };

    return (
        <ConfirmDialog
            title="Approve buzz notifications"
            text="Are you sure you want to approve buzz notifications? Once approved, they cannot be turned off."
            hidden={!isOpen}
            confirm={{ onClick: handleConfirmation }}
            cancel={{ onClick: onClose }}
        />
    );
};
